import {TweenMax, Power2} from 'gsap';
const EventEmitter = require('eventemitter3');

const _init = function (ui) {
    ui.el.dataset.active = true;

    TweenMax.set(ui, {
        opacity: 0
    });
};

const _show = function () {
    const ui = this;

    ui.el.dataset.active = true;
    TweenMax.fromTo(ui, 1.4, {
        delay: 1,
        opacity: 0,
        ease: Power2.easeOut
    },
    {
        opacity: 1
    });
};

const _hide = function () {
    const ui = this;

    ui.el.dataset.active = true;
    TweenMax.fromTo(
        ui,
        1.4,
        {
            delay: 1,
            opacity: 1,
            ease: Power2.easeOut
        },
        {
            opacity: 0
        }
    );
};

const _enable = function () {
    const ui = this;
    if (ui._enabled) return;
    _addEventListeners(ui);
    ui._enabled = true;
};

const _disable = function () {
    const ui = this;
    if (!ui._enabled) return;
    _addEventListeners(ui, false);
    ui._enabled = false;
};

const _destroy = function () {
    const ui = this;
    ui.disable();
    ui.removeAllListeners();

    // delete ui.el.data.uiController;
};


const _addEventListeners = function (ui, b) {

    if (b === false) {
        ui.el.removeEventListener('click', ui._onClick);
        return;
    }

    ui._onClick = () => {
        ui.emit('go');
    };

    ui.el.addEventListener('click', ui._onClick);
};


module.exports = el => {

    if (el.data && el.data.uiController) return el.data.uiController;

    const ui = new EventEmitter();
    ui.el = el;
    
    ui.show = _show.bind(ui);
    ui.hide = _hide.bind(ui);
    ui.enable = _enable.bind(ui);
    ui.disable = _disable.bind(ui);
    ui.destroy = _destroy.bind(ui);

    _init(ui);

    return ui;
}


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/ui/CoverNextButton.js